import io from 'socket.io-client'

const isLocal = window.location.href.includes('localhost')
if (isLocal) {
  console.warn('socket-io functionality disabled for localhost')
}

const socket = isLocal
  ? { connect: () => {}, emit: () => {}, on: () => {}, off: () => {} }
  : io(process.env.REACT_APP_SOCKET_BASEURL + 'conversation', {
      transports: ['polling'],
    })
const socket1 = isLocal
  ? { emit: () => {} }
  : io(process.env.REACT_APP_SOCKET_BASEURL + 'visit', { transports: ['polling'] })

export { socket, socket1 }

export const disconnectSocket = () => {
  if (socket) socket.disconnect()

  if (socket1) socket1.disconnect()
}
